import { ChangeDetectionStrategy, Component, OnInit, WritableSignal, signal } from '@angular/core';
import { UserFacade } from '@nx-ratenow/core/data-access-user';
import { environment } from '@nx-ratenow/core/environment';
import { UiUserMenuComponent } from '@nx-ratenow/core/feature-user-menu';
import { PopoverService } from '@nx-ratenow/shared/feature-popover';
import { Observable, of } from 'rxjs';
import { distinctUntilChanged, filter, map, startWith, switchMap } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'nx-ratenow-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarUserComponent implements OnInit {
  userMenuOpen$: Observable<boolean> = of(false);

  imageId: WritableSignal<string> = signal('');

  userLoggedName: string;

  defaultImage: string = '/assets/img/illustrations/man.png';

  constructor(
    private userFacade: UserFacade,
    private readonly popoverService: PopoverService
  ) {}

  ngOnInit(): void {
    this.userFacade.userLogged$
      .pipe(
        filter((val) => val != null),
        distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr))
      )
      .subscribe((userLogged) => {
        this.userLoggedName = userLogged.personName;
        this.imageId.set(`${environment.serverBackend}/image/${userLogged.personImageId}`);
      });
  }

  openProfileMenu(origin: HTMLDivElement): void {
    this.userMenuOpen$ = of(
      this.popoverService.open({
        content: UiUserMenuComponent,
        origin,
        offsetY: 55,
        width: 210,
        position: [
          {
            originX: 'center',
            originY: 'top',
            overlayX: 'center',
            overlayY: 'bottom'
          }
        ]
      })
    ).pipe(
      switchMap((popoverRef) => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true)
    );
  }
}
